import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=6435f042"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6435f042')) {
      api.createRecord('6435f042', component.options)
    } else {
      api.reload('6435f042', component.options)
    }
    module.hot.accept("./Legal.vue?vue&type=template&id=6435f042", function () {
      api.rerender('6435f042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Legal.vue"
export default component.exports